import React from 'react'
import { useEntities } from 'state/entities'
import { compact, pruneBy } from 'utilities/array'
import { cls } from 'utilities/dom'
import { EntitiesList } from './s'
import Loader from 'components/loader'
import Entity from './entity'
import { Organization, Company, Team, SmartDocumentTemplate } from 'components/feather'
import {
    MapPin as Location,
    Shield as JobTitle,
    UserCheck as Role,
    Menu as ProcessTemplate
} from 'styled-icons/feather'
import LoadMore from 'components/load-more'

const Entities = ({ type, fixed, filtered, picked, pick, sticky, created, searching = false, filtering = false, emptyOption, salt }) => {
    const {
        items: fetched,
        isLoading
    } = useEntities()

    const items = filtered ?? fixed ?? pruneBy([
        ...sticky,
        emptyOption,
        ...created,
        ...fetched
    ])

    const className = cls([type === 'competenceType' && 'large'])

    return (
        <>
            {isLoading && <Loader />}
            <EntitiesList {...(className ? { className } : null)}>
                {items.map((entity, index) => {
                    type = entity?.type ?? type
                    const icon = typeToIconMap[type]

                    return (
                        <Entity
                            entity={entity}
                            picked={picked}
                            pick={pick}
                            type={type}
                            index={index}
                            icon={icon}
                            searching={searching}
                            filtering={filtering}
                            isEmptyOption={!!entity.id && entity.id === emptyOption?.id}
                            salt={`${salt}:entities`}
                            key={compact([
                                salt,
                                'entities',
                                entity.id,
                                (picked?.id === entity.id) && 'picked'
                            ]).join(':')} />
                    )
                })}
                {!fixed && (
                    <LoadMore
                        useItems={useEntities}
                        appearance="list"
                        auto />
                )}
            </EntitiesList>
        </>
    )
}

const typeToIconMap = {
    organization: props => <Organization {...props} />,
    company: props => <Company {...props} />,
    team: props => <Team {...props} />,
    location: props => <Location {...props} />,
    jobTitle: props => <JobTitle {...props} />,
    role: props => <Role {...props} />,
    processTemplate: props => <ProcessTemplate {...props} />,
    smartTemplate: props => <SmartDocumentTemplate {...props} />
}

export default Entities